module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('profile-overview'), _vm._v(" "), _c('player'), _vm._v(" "), _c('readouts'), _vm._v(" "), _c('div', {
    staticClass: "chart-wrap"
  }, [_c('chart-guide'), _vm._v(" "), _c('chart')], 1), _vm._v(" "), _c('leaflet-map')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7ef7b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 200
// module chunks = 1